import * as React from "react";
import { UitkImage } from "uitk-react-images";
import { UitkLink } from "uitk-react-link";
import { ImageMediaType } from "src/components/flexComponents/Content/typings";

export const ImageEditorialWithLink = ({ mediaUrl, mediaAlt, clickUrl }: ImageMediaType) => (
  <UitkLink>
    <a href={clickUrl}>
      <UitkImage key={mediaUrl} alt={mediaAlt} src={mediaUrl} className="images-size" />
    </a>
  </UitkLink>
);

export default ImageEditorialWithLink;
